export default "__VITE_ASSET__CpCRMF8B__"